import React from 'react';
import { IOldIconProps } from './type';

const RebuyCart: React.FC<IOldIconProps> = ({
  width,
  height,
  color = '#000',
  ...props
}) => {
  return (
    <svg
      width={width || 32}
      height={height || 32}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.433 10c0-3.436 2.853-6.25 6.408-6.25 3.556 0 6.409 2.814 6.409 6.25s-2.853 6.25-6.409 6.25a6.483 6.483 0 01-3.867-1.266.75.75 0 10-.891 1.207 7.983 7.983 0 004.758 1.559c4.352 0 7.909-3.454 7.909-7.75 0-4.296-3.557-7.75-7.909-7.75-4.306 0-7.833 3.382-7.907 7.614l-.41-.4a.75.75 0 00-1.048 1.072l1.952 1.91a.75.75 0 001 .044l2.333-1.91a.75.75 0 00-.95-1.16l-1.356 1.108a6.157 6.157 0 01-.022-.528zm7.158-3.182a.75.75 0 00-1.5 0V10a.75.75 0 00.226.536l1.896 1.855a.75.75 0 001.05-1.073L18.59 9.684V6.818zM1.766 6.713a.75.75 0 11.467-1.425l1.955.64a3.75 3.75 0 012.467 2.64l2.54 9.987a2.25 2.25 0 002.18 1.695h11.953a2.25 2.25 0 002.13-1.527l2.832-8.348a.75.75 0 111.42.482l-2.83 8.348a3.742 3.742 0 01-1.005 1.547A3.75 3.75 0 1121 21.75H14a3.75 3.75 0 11-5.05-.89 3.742 3.742 0 01-1.208-1.935l-2.54-9.988a2.25 2.25 0 00-1.48-1.584l-1.956-.64zM8.75 24a2.25 2.25 0 114.5 0 2.25 2.25 0 01-4.5 0zM24 21.75a2.25 2.25 0 100 4.5 2.25 2.25 0 000-4.5z"
        fill={color}
      />
    </svg>
  );
};

export default RebuyCart;
